import { createLucideIcon } from 'lucide-react'

/**
 * The YouTube glyph, rebuilt locally.
 *
 * lucide dropped every brand mark in v1 (trademark), and `Youtube` went with
 * them — but the name is DATA here, not a design choice: `specialist.icon`
 * stores the string `'youtube'` and the catalogue seed ships rows carrying it.
 * Swapping the map to a generic play button would silently relabel every one of
 * those rows, so the glyph is restored instead.
 *
 * Built with `createLucideIcon` rather than as a hand-written `<svg>` so it stays
 * a real `LucideIcon`: `SPECIALIST_ICONS` keeps its type, and the card can still
 * pass `size` / `strokeWidth` and inherit `currentColor`. The node below is
 * lucide's own (ISC), which is also why this reads as one of the set rather than
 * as the multicolour brand mark — unlike {@link GoogleMark}, it sits inside a
 * gradient disc where full colour would smudge.
 */
export const YoutubeGlyph = createLucideIcon('Youtube', [
  [
    'path',
    {
      d: 'M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17',
      key: '1q2vi4',
    },
  ],
  ['path', { d: 'm10 15 5-3-5-3z', key: '1jp15x' }],
])
